import { createContext } from 'react';
import { Api } from '../__generated__/Api';

export interface SecurityData {
  access_token: string;
}

export const ApiContext = createContext<Api<SecurityData> | null>(null);
